import { TaxDataValue } from '@app/app/interfaces/tax-data-value.struct';

export class GetTaxDataValues {
  static readonly type = `[TaxData] GetTaxDataValues`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class UpsertTaxDataValues {
  static readonly type = `[TaxData] CreateTaxDataValues`;
  constructor(
    public borrowerId: number,
    public taxDataValues: Partial<TaxDataValue>[],
  ) {}
}
